module.exports = __webpack_public_path__ + "static/CDO-c2aa345f0ec9b54f487287b71038fb68.png";